var r={switch:"lds-form-switch-group--switch",description:"lds-form-switch-group--description",error:"lds-form-switch-group--error"};export{r as default};
